import axios from "axios";

import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import CreateGetVesselImagesAction from "./CreateGetVesselImagesByLicenceIdAction";

export default function (file) {
    return (dispatch, getState) => {
        dispatch(CreateDataRetrievalBegunAction());

        const { currentApplication } = getState();

        const updatedLicenceApplication = {
            id: Number(currentApplication.id)
        };

        var formData = new FormData();
        formData.append("image", file);

        axios({
            method: "POST",
            url: "api/FileUpload/UploadVesselPhoto?licenceApplicationId=" + updatedLicenceApplication.id,
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData,
            withCredentials: true
        })
        .then((response) => {
            dispatch(CreateGetVesselImagesAction(updatedLicenceApplication.id));
            dispatch(CreateDataRetrievalEndedAction());
        })
        .catch((error) => {
            dispatch(CreateDataRetrievalEndedAction());
        });
    };
}
